/**
 * Reads the Azure Maps subscription key from the Vite environment.
 *
 * Absent by default: without a key the map provider reports itself unconfigured and the UI shows the
 * map-unavailable state while the list keeps working. The real key is a step-0b concern (it needs an
 * Azure Maps account and a cost model), so the app must degrade gracefully until then.
 *
 * @returns The key, or an empty string when none is set.
 */
export function azureMapsKey(): string {
  return (import.meta.env['VITE_AZURE_MAPS_KEY'] as string | undefined) ?? '';
}
